import classNames from 'classnames';
import React, { memo } from 'react';
import { AssessmentListItemType } from '@redux/tasks/tasksTypes';
import { NotepadIcon } from 'components/Icons';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './AssessmentMenuOption.scss';

type Props = {
  option: AssessmentListItemType;
  onClick?: (option: AssessmentListItemType) => void;
  containerStyle?: string;
};

export const AssessmentMenuOption: React.FC<Props> = memo(({ option, onClick, containerStyle }) => {
  return (
    <div className={classNames(style.container, containerStyle)} key={option.id} onClick={() => onClick?.(option)}>
      <NotepadIcon width={32} height={32} color={Color.LIGHT_BLUE_700} />
      <div className={style.textWrapper}>
        <Text variant="md">{option.name}</Text>
        <Text variant="md" className={style.description}>
          {option.description}
        </Text>
      </div>
    </div>
  );
});
